import { configureStore, ThunkAction } from '@reduxjs/toolkit';
import { Action, combineReducers } from 'redux';
import { createWrapper } from 'next-redux-wrapper';
import homePageSlice from '@/store/slices/homePageSlice';
import articlePageSlice from '@/store/slices/articlePageSlice';
import categoryPageSlice from '@/store/slices/categoryPageSlice';
import searchPageSlice from '@/store/slices/searchPageSlice';
import headerAndFooterSlice from '@/store/slices/headerAndFooterSlice';
import sortFilterSlice from '@/store/slices/sortFilterSlice';
import authorPageSlice from '@/store/slices/authorPageSlice';

// Store setup
const reducers = {
  [homePageSlice.name]: homePageSlice.reducer,
  [articlePageSlice.name]: articlePageSlice.reducer,
  [categoryPageSlice.name]: categoryPageSlice.reducer,
  [searchPageSlice.name]: searchPageSlice.reducer,
  [headerAndFooterSlice.name]: headerAndFooterSlice.reducer,
  [sortFilterSlice.name]: sortFilterSlice.reducer,
  [authorPageSlice.name]: authorPageSlice.reducer,
};

const reducer = combineReducers(reducers);

const makeStore = () => configureStore({
  reducer,
  devTools: true,
  middleware: getDefaultMiddleware => getDefaultMiddleware(),
});

export const wrapper = createWrapper<AppStore>(makeStore);

export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;
export type AppDispatch = AppStore['dispatch'];
